export function isUndefined (value) {
  return typeof value === 'undefined'
}

export function isDefined (value) {
  return typeof value !== 'undefined'
}

export function isFile (value) {
  return isObject(value) && value instanceof File
}

export function isObject (value) {
  return value !== null && typeof value === 'object'
}

export function isString (value) {
  return typeof value === 'string' || value instanceof String
}

export function isNumber (value) {
  return typeof value === 'number'
}

export function isFunction (value) {
  return typeof value === 'function'
}

export function objectExtend (a, b) {
  if (a == null || b == null) {
    return a
  }

  Object.keys(b).forEach(function (key) {
    if (Object.prototype.toString.call(b[key]) === '[object Object]') {
      if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
        a[key] = b[key]
      } else {
        a[key] = objectExtend(a[key], b[key])
      }
    } else {
      a[key] = b[key]
    }
  })

  return a
}
